import React from "react";

import ParticipantSubmission from "../templates/ParticipantSubmission";

const ParticipantSubmissionPage = () => <ParticipantSubmission />;

export default ParticipantSubmissionPage;